import { DataGrid } from "@mui/x-data-grid";
import { indiaDate } from "./indiaDate";
import { formatAmount } from "./money";

const DATE_FIELD = /(date|_at|licence_end|licence_start)$/i;
const MONEY_FIELD = /(?:^|_)(?:amount|balance|price|value|bid)$/i;

export default function IndiaDataGrid({ columns, ...props }) {
  const next = (columns || []).map((column) => {
    if (!column || column.valueFormatter || column.renderCell) return column;
    const field = String(column.field || "");
    if (DATE_FIELD.test(field)) return { ...column, valueFormatter: (value) => indiaDate(value) };
    if (MONEY_FIELD.test(field)) return { ...column, valueFormatter: (value) => formatAmount(value) };
    return column;
  });
  return <DataGrid columns={next} {...props} />;
}
